<template>
  <view-page
      :baseRoute='baseRoute'
      :entity='entity'
      :button-access="componentAccess"
      :model-entity="modelEntity"
      :page-title="setPageTitle"
  >

    <template v-slot="{ model }">
      <product-form
          v-if="model"
          readonly
          v-model="model"
          card-title="View Product"
          :ProductCompanyType="ProductCompanyType"
          :ProductCompanyType_FK="ProductCompanyType_FK"
      />
    </template>

    <template v-slot:extra-button="{ model }">
      <vs-button
          v-if="model"
          class="mt-2 ml-4"
          color="light"
          @click="openEnableAlert(model)"
      >
        {{ model.IsEnabled ? "Deactivate" : "Activate" }}
      </vs-button>
    </template>
  </view-page>
</template>

<script>

import ProductForm from "@/views/pages/products-ipr/ProductForm";
import ViewPage from "@/views/components/Views/ViewPage";
import EnablePublishMixin from '../../../components/mixins/EnablePublishMixin';
import NotificationMixin from '../../../components/mixins/NotificationMixin';
import IprProductCompanyTypeMixin from "@/components/mixins/IprProductCompanyTypeMixin";

export default {
  name: "ProductDetails",
  components: {
    ProductForm,
    ViewPage,
  },
  mixins: [NotificationMixin, EnablePublishMixin, IprProductCompanyTypeMixin],
  data() {
    return {
      baseRoute: `${this.ProductCompanyType}.products-ipr`,
      entity: 'Product',
      modelEntity: this.$api[this.companyTypeApiModel('productsIpr')],
      title: '',
      componentAccess: {
        canEdit: {
          route: `${this.ProductCompanyType}.products-ipr.edit`,
          access: false,
        },
        canDelete: {
          route: `${this.ProductCompanyType}.products-ipr.delete`,
          access: false,
        },
      }
    };
  },
  methods: {
    setPageTitle(params) {
      if (!params.ProductCode) {
        return '';
      }

      return "Product: " + params.ProductCode;
    }
  }
};
</script>

<style scoped>

</style>
